// src/components/media/PixelatedImage.tsx
"use client";
import React from 'react';

type Props = { src: string; alt: string; placeholderSrc: string; className?: string; onError?: () => void };

export default function PixelatedImage({ src, alt, placeholderSrc, className = '', onError }: Props) {
  const [ready, setReady] = React.useState(false);
  const imgRef = React.useRef<HTMLImageElement | null>(null);

  React.useEffect(() => {
    const el = imgRef.current;
    if (!el) return;
    // If loaded from cache, onLoad may not fire; mark ready when complete
    if (el.complete && el.naturalWidth > 0) setReady(true);
  }, [src]);
  return (
    <div className={`img-wrap ${ready ? 'is-ready' : ''} ${className}`}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img className="img-lqip" src={placeholderSrc} alt="" aria-hidden />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img ref={imgRef} className="img-full" src={src} alt={alt} loading="lazy" onLoad={() => setReady(true)} onError={onError} />
    </div>
  );
}
